import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=3a70e870&scoped=true"
import script from "./ImgUpload.vue?vue&type=script&lang=js"
export * from "./ImgUpload.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=3a70e870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70e870",
  null
  
)

export default component.exports